import { IS_DEV } from './env'

/**
 * 可能存在直接使用静态公共资源的情况，
 * 组件封装内部需要调用该数据来处理，如果业务上直接使用静态公共资源也需要使用该函数处理。
 *
 * 避免手动配置 cdnPrefix 请使用 useNormalizePublicSrc hook 来代替
 */
export const dangerousNormalizePublicSrc = (
  src: string,
  cdnPrefix: string | null,
) => {
  if (
    src.startsWith('http://') ||
    src.startsWith('https://') ||
    src.startsWith('data:') ||
    src.startsWith('blob:')
  ) {
    return src
  }
  if (!IS_DEV && cdnPrefix) {
    return `${cdnPrefix}${src}`
  }
  return src
}
